import { useCallback, useEffect, useState } from 'react'

import { Box, Icon, Table, TableHeader, Text } from '@fairfashion/design-system'

import { ICompanyProductionResponse } from '../../sdk/company-production/company-production.types'
import { sdk } from '../../services/sdk'

export const CompanyProduction = ({ companyId }: { companyId: string }) => {
  const [data, setData] = useState<ICompanyProductionResponse[] | null>(null)
  const fetchCompanyProductions = useCallback(async () => {
    const response =
      await sdk.companyProduction.getCompanyProductions(companyId)

    setData(response)
  }, [companyId])

  useEffect(() => {
    fetchCompanyProductions()
  }, [companyId])
  const getMonthYearText = (companyProduction: ICompanyProductionResponse) => {
    return `${companyProduction?.month.toString().padStart(2, '0')}/${
      companyProduction?.year
    }`
  }
  const getWithTaxUnit = (
    value: number,
    companyProduction: ICompanyProductionResponse,
  ) => {
    return `${value} ${companyProduction.companyProductionCapacity.taxUnit}`
  }
  const getVariation = (companyProduction: ICompanyProductionResponse) => {
    const companyCapacity = companyProduction.companyProductionCapacity.capacity

    const variation =
      ((companyProduction.totalReceived - companyCapacity) / companyCapacity) *
      100

    const variationS = Number.isInteger(variation)
      ? variation.toString()
      : variation.toFixed(1)

    return (
      <Box justifyContent="center" alignItems="center" gap={1}>
        <Text>{`${variationS} %`}</Text>
        {(variation >= 20 || variation <= -20) && (
          <Icon name="error_warning" color="error" size={20} />
        )}
      </Box>
    )
  }
  const headers: TableHeader[] = [
    {
      key: 'yearMonth',
      label: 'Mês/Ano',
      customRender: (data) => <strong>{getMonthYearText(data)}</strong>,
    },
    {
      key: 'finishedItemCategory.name',
      label: 'Tipo de produto',
      customRender: (data) => data.finishedItemCategory?.name,
    },
    {
      key: 'monthlyCapacity',
      label: 'Capacidade produtiva mensal',
      customRender: (data) =>
        getWithTaxUnit(data.companyProductionCapacity.capacity, data),
    },
    {
      key: 'totalSent',
      label: 'Total enviado no mês para produzir',
      customRender: (data) => getWithTaxUnit(data.totalSent, data),
    },
    {
      key: 'totalReceived',
      label: 'Total produzido no mês',
      customRender: (data) => getWithTaxUnit(data.totalReceived, data),
    },

    {
      key: 'variation',
      label: 'Variação % (capacidade x produzido)',
      customRender: (data) => getVariation(data),
    },
  ]
  return (
    <Box width="100%" direction="column">
      {data && <Table data={data} headers={headers} />}
      {!data ||
        (data.length === 0 && (
          <Box width="100%" justifyContent="center" padding={6}>
            <Text align="center">Não há dados</Text>
          </Box>
        ))}
    </Box>
  )
}
